// src/components/Preloader.jsx
import React, { useEffect } from 'react';

const Preloader = () => {
  useEffect(() => {
    // Sayfa yüklendikten sonra preloader'ı gizle
    const timer = setTimeout(() => {
      const el = document.querySelector('.preloader');
      if (el) el.style.display = 'none';
    }, 500); // 1 saniye sonra kaybolsun (isteğe bağlı süredir)

    return () => clearTimeout(timer);
  }, []);

  return <div className="preloader"></div>;
};

export default Preloader;